<div class="discover-filters" stxtClickOutside (clickOutside)="isShowFilter = false">
  <div class="discover-filters_items">
    <button
      *ngFor="let filter of filters"
      [ngClass]="{ active: isFilterActive(filter) }"
      (click)="selectFilter(filter)"
      class="discover-filters_filter btn-nostyle"
    >
      <div>
        {{ filter.name }}
        <div
          *ngIf="
            filter === activeFilter && activeFilter.isMultiple && nationalityFiltersList.length > 0
          "
          class="discover-filters_filter__selections"
        >
          •
          <span *ngIf="nationalityFiltersList.length === 1">
            {{ nationalityFiltersList[0].flag }}
          </span>
          <span
            *ngIf="
              nationalityFiltersList.length > 1 &&
              nationalityFiltersList.length !== nationalityFilters.length
            "
          >
            {{ nationalityFiltersList.length }}
          </span>
          <span *ngIf="nationalityFiltersList.length === nationalityFilters.length">All</span>
        </div>
        <stxt-svg-icon
          *ngIf="filter?.isMultiple"
          [iconConfig]="arrowDownSvg"
          [ngClass]="{ rotated: isShowFilter }"
          class="discover-filters_icon"
        ></stxt-svg-icon>
      </div>
    </button>
  </div>
  <ng-container *ngIf="isShowFilter && activeFilter?.isMultiple">
    <stxt-dropdown-filter
      [@fade]
      [filters]="nationalityFilters"
      [selectedFilters]="nationalityFiltersList"
      (filterSelected)="selectNationalityFilter($event)"
      class="discover-filters_filter__dropdown absolute"
    ></stxt-dropdown-filter>
  </ng-container>
</div>
